import styled from 'styled-components'

export const FormContainer = styled.div`
  margin-top: 16px;
  width: 100%;
`
